<template>
  <div>
    <v-dialog v-model="model" max-width="1200" persistent scrollable>
      <material-card
        :title="
          $t(
            'components.plan_benefit_rules.file_dialog.add_member_group_rules_configuration'
          )
        "
        :color="$vuetify.theme.themes.light.success"
        icon="add"
        v-if="item"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-row justify-center>
              <v-col cols="12">
                <v-btn color="success" @click="ruleTypesDialog = true">
                  {{
                    $t(
                      "components.plan_benefit_rules.import_benefit_rules_configuration_dialog.rules_types"
                    )
                  }}
                </v-btn>
              </v-col>
              <v-col cols="12" sm="8">
                <trans-multi-select2
                  v-model="item.MemberGroups"
                  :items="memberGroups"
                  :label="$t('globals.member_groups')"
                  field="Name"
                  itemValue="IdentityId"
                  class="required"
                  :rules="[$rules.atLeastOne]"
                ></trans-multi-select2>
              </v-col>
              <v-col cols="12" sm="4">
                <v-checkbox
                  v-model="item.noRules"
                  :label="
                    $t(
                      'components.plan_benefit_rules.import_benefit_rules_configuration_dialog.no_rules_files'
                    )
                  "
                ></v-checkbox>
              </v-col>
              <template v-if="!item.noRules">
                <v-col cols="12">
                  <v-file-input
                    show-size
                    accept=".xlsx"
                    :label="
                      $t(
                        'components.plan_benefit_rules.import_benefit_rules_configuration_dialog.benefit_rules'
                      )
                    "
                    ref="file"
                    @change="handleFileChange"
                    :rules="[$rules.required]"
                    :class="'required'"
                    v-model="ruleFile"
                  />
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    show-size
                    accept=".xlsx"
                    :label="
                      $t(
                        'components.plan_benefit_rules.import_benefit_rules_configuration_dialog.plan_group_limit_rules'
                      )
                    "
                    ref="ruleFileGroupLimit"
                    v-on:change="handleFileChangeGroupLimit"
                    v-model="ruleFileGroupLimit"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    :label="
                      $t(
                        'components.plan_benefit_rules.import_benefit_rules_configuration_dialog.plan_health_limit_rules'
                      )
                    "
                    v-model="item.HealthLimitRules"
                    clearable
                  />
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    :label="
                      $t(
                        'components.plan_benefit_rules.import_benefit_rules_configuration_dialog.ShowHealthBenefitBalance'
                      )
                    "
                    v-model="item.ShowHealthBenefitBalance"
                    :disabled="item.HealthLimitRules===null || item.HealthLimitRules === undefined || item.HealthLimitRules === ''"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    :label="
                      $t(
                        'components.plan_benefit_rules.import_benefit_rules_configuration_dialog.plan_dental_limit_rules'
                      )
                    "
                    v-model="item.DentalLimitRules"
                    clearable
                  />
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    :label="
                      $t(
                        'components.plan_benefit_rules.import_benefit_rules_configuration_dialog.ShowDentalBenefitBalance'
                      )
                    "
                    v-model="item.ShowDentalBenefitBalance"
                    :disabled="item.DentalLimitRules===null || item.DentalLimitRules === undefined || item.DentalLimitRules === ''"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    :label="
                      $t(
                        'components.plan_benefit_rules.import_benefit_rules_configuration_dialog.plan_limit_rules'
                      )
                    "
                    v-model="item.LimitRules"
                    clearable
                  />
                </v-col>
              </template>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              item = null;
              $emit('close');
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn color="primary" @click="save" :disabled="!valid">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <rule-types-dialog
      :model="ruleTypesDialog"
      :ruleTypes="ruleTypes"
      @close="onClose"
    />
  </div>
</template>

<script>
import TransMultiSelect2 from "../TransMultiSelect2.vue";
import RuleTypesDialog from "@/components/PlanBenefitsRules/RuleTypesDialog.vue";
export default {
  components: { TransMultiSelect2, RuleTypesDialog },
  props: [
    "model",
    "value",
    "file",
    "fileGroupLimit",
    "allGroups",
    "usedGroups",
    "ruleTypes",
  ],
  data() {
    return {
      error: null,
      valid: false,
      item: null,
      errors: [],
      ruleFileGroupLimit: null,
      ruleFile: null,
      memberGroups: [],
      ruleTypesDialog: false,
    };
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          console.log(this.value, this.file, this.fileGroupLimit);
          this.loadData();
        } else {
          this.item = null;
          this.ruleFile = null;
          this.ruleFileGroupLimit = null;
          this.memberGroups = [];
        }
      },
    },
    value: {
      handler(v) {
        this.loadData(v);
      },
    },
  },
  mounted() {
    this.loadData(this.value);
  },
  methods: {
    onClose() {
      this.ruleTypesDialog = false;
    },
    loadData(v) {
      if (v) {
        this.item = JSON.parse(JSON.stringify(v));
        if (this.file) {
          this.ruleFile = this.file;
        }
        if (this.fileGroupLimit) {
          this.ruleFileGroupLimit = this.fileGroupLimit;
        }
      } else {
        this.item = {
          Identifier: Math.random().toString(),
          File: {},
          MemberGroups: [],
        };
      }
      if (this.allGroups !== null && this.allGroups !== undefined) {
        this.memberGroups = this.allGroups.filter(
          (o) =>
            this.usedGroups.filter((oo) => oo === o.IdentityId).length === 0 ||
            this.item.MemberGroups.filter(
              (oo) => oo.IdentityId === o.IdentityId
            ).length > 0
        );
        console.log(this.memberGroups);
      }
    },
    handleFileChange(file) {
      console.log("--------------------", file);
      if (!file) {
        this.ruleFile = null;
        this.item.File = null;
        this.errors = [];
        return;
      }
      if (file.length == 0) {
        this.ruleFile = null;
        this.item.File = null;
        this.errors = [];
        return;
      }
      // this.item.File = {
      //   File: file,
      //   Name: file.name,
      // };
      this.ruleFile = file;
      this.item.File = file.name;
    },
    handleFileChangeGroupLimit(file) {
      console.log("--------------------", file);
      if (!file) {
        this.ruleFileGroupLimit = null;
        this.item.FileGroupLimit = null;
        this.errors = [];
        return;
      }
      if (file.length == 0) {
        this.ruleFileGroupLimit = null;
        this.item.FileGroupLimit = null;
        this.errors = [];
        return;
      }
      this.ruleFileGroupLimit = file;
      this.item.FileGroupLimit = file.name;
    },
    save() {
      if (this.item.noRules) {
        this.$emit("save", {
          item: this.item,
        });
      } else {
        this.$emit("save", {
          item: this.item,
          file: this.ruleFile,
          fileGroupLimit: this.ruleFileGroupLimit,
        });
      }
    },
  },
};
</script>
